export function findAndDecode(obj, props) {
  if (obj?.constructor.name !== 'Object') return obj;
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (obj[key]?.constructor.name === 'Object') {
      obj[key] = findAndDecode(obj[key], props);
    }
    if (obj[key]?.constructor.name === 'Array') {
      obj[key] = obj[key].map((el) => findAndDecode(el, props));
    }
    if ((typeof props !== 'string' && props.includes(key)) || props === key) {
      obj[key] = decodeURIComponent(obj[key]);
    }
  }
  return obj;
}
